import { useEffect, useState, useRef } from "react";
import axios from "axios";

import ImageZoom from "js-image-zoom";
import MetaComponent from "../../components/MetaComponent.js";
import { useParams } from "react-router-dom";
import { useNavigate, useHref } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import Link from '@mui/material/Link';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Tooltip from '@mui/material/Tooltip';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';
import isLength from 'validator/lib/isLength';
import equals from 'validator/lib/equals';
import dayjs from 'dayjs'

// swiper
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import 'swiper/css/autoplay';
import 'swiper/css/scrollbar';

import './../assets/styles.css';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Scrollbar, Autoplay } from 'swiper/modules';
import { FreeMode, Thumbs } from 'swiper/modules';

import DownloadTwoToneIcon from '@mui/icons-material/DownloadTwoTone';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';

const config = require("../../constants/constants.js")
const { strCurrency, strEuroCurrency } = require('../../utils/currencyUtils.js')

const size_linkToAllEvents = 40;

const EventDetailsPageComponent = ({
  addToCartReduxAction,
  reduxDispatch,
  getEventDetails,
  userInfo,
  writeReviewApiRequest
}) => {

  const { id } = useParams();
  const [quantity, setQuantity] = useState(1);
  const [showCartMessage, setShowCartMessage] = useState(false);
  const [event, setEvent] = useState([]);
  const [images, setImages] = useState([]);
  const [pdfs, setPdfs] = useState([]);
  const [pathPdfsToDwn, setPathPdfsToDwn] = useState("");
  const [namePdfsToDwn, setNamePdfsToDwn] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [eventReviewed, setEventReviewed] = useState(false);

  let navigate = useNavigate();

  const url_elencoEventi = "/eventi";
  const url_image_elencoEventi = config.URL_IMAGES_CUSTOMER1 + "elenco-eventi.png";
  const help_image_elencoEventi = "elenco degli eventi";

  const messagesEndRef = useRef(null);

  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const addToCartHandler = (e) => {
    reduxDispatch(addToCartReduxAction(id, quantity));
    setShowCartMessage(true);
  };

  useEffect(() => {
    if (eventReviewed) {
      setTimeout(() => {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      }, 200)
    }
  }, [eventReviewed])

  useEffect(() => {
    if (event.images) {
      var options = {
        // width: 400,
        // zoomWidth: 500,
        // fillContainer: true,
        // zoomPosition: "bottom",
        scale: 2,
        offset: { vertical: 0, horizontal: 0 },
      };

      event.images.map(
        (image, id) =>
          new ImageZoom(document.getElementById(`imageId${id + 1}`), options)
      );
    }
  });

  useEffect(() => {
    getEventDetails(id)
      .then((data) => {
        setEvent(data);
        setImages(data?.images);
        setPdfs(data?.pdfs);
        setPathPdfsToDwn(data?.pdfs[0].path);
        setNamePdfsToDwn(data?.pdfs[0].name);
        setLoading(false);
        //console.log("[useEffect] images =", data.images);
        //console.log("[useEffect] pdfs =", data.pdfs);
        //console.log("[useEffect] pathPdfsToDwn =", data?.pdfs[0].path);
      })
      .catch((er) =>
        setError(
          er.response.data.message ? er.response.data.message : er.response.data
        )
      );
  }, [id, eventReviewed]);

  function verificaContieneCaratteri(value) {
    console.log("[verificaMaggioveDiZero] value =", (value === ""))
    if (value === "") {
      return "true";
    } else return "";
  }

  //  const Item = styled(Paper)(({ theme }) => ({
  //    backgroundColor: '#b6d6e0ff',
  const Item = styled(Box)(({ theme }) => ({
    backgroundColor: '#bfdae3ff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: (theme.vars ?? theme).palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }));

  const goBack = () => {
    navigate(-1);
  }

  const [applicativo, setApplicativo] = useState("");
  const [ragioneSociale, setRagioneSociale] = useState("");
  const [email, setEmail] = useState("");
  const [telefonoCallFromSite, setTelefonoCallFromSite] = useState("");
  const [linkWhatsapp, setLinkWhatsapp] = useState("");
  const [linkFacebook, setLinkFacebook] = useState("");
  const [linkInstagram, setLinkInstagram] = useState("");
  const [linkTwitter, setLinkTwitter] = useState("");
  const [linkLinkedin, setLinkLinkedin] = useState("");
  const [urlSiteImageServer, setUrlSiteImageServer] = useState("");
  const [urlCustomerImageServer, setUrlCustomerImageServer] = useState("");
  const [isShopActive, setIsShopActive] = useState("");
  const [isIconLoginActive, setIsIconLoginActive] = useState("");

  const [showPriceProducts, setShowPriceProducts] = useState("");
  const [showPriceServices, setShowPriceServices] = useState("");
  const [showPriceEvents, setShowPriceEvents] = useState("");
  const [showSectionAddCardProducts, setShowSectionAddCardProducts] = useState("");
  const [showSectionAddCardServices, setShowSectionAddCardServices] = useState("");
  const [showSectionAddCardEvents, setShowSectionAddCardEvents] = useState("");
  const [showReviews, setShowReviews] = useState("");
  
  const [showCatalogDownloadInDetailsPage, setShowCatalogDownloadInDetailsPage] = useState("");

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  
  const getConfigByProgressivoApiRequest = async (progressivoRagSoc) => {
    console.log("[getConfigByProgressivoApiRequest] leggo const con progressivo =", progressivoRagSoc);
    const url = `/api/configs/progressivo/` + progressivoRagSoc;
    const { data } = await axios.get(url);
    return data
  }

  useEffect(() => {
    getConfigByProgressivoApiRequest('0001').then((data) => {
      console.log(`data =`, data);
      setApplicativo(data?.applicativo);
      setRagioneSociale(data?.ragioneSociale);
      setEmail(data?.email);
      setTelefonoCallFromSite("tel:" + data?.telefonoCallFromSite)
      setLinkWhatsapp("https://wa.me/" + data?.linkWhatsapp);
      setLinkFacebook(data?.linkFacebook);
      setLinkInstagram(data?.linkInstagram);
      setLinkTwitter(data?.linkTwitter);
      setLinkLinkedin(data?.linkLinkedin);
      setUrlSiteImageServer(data?.urlSiteImageServer);
      setUrlCustomerImageServer(data?.urlCustomerImageServer);
      //setIsShopActive(data?.isShopActive === "Si" ? true : false);
      //setIsIconLoginActive(data?.isIconLoginActive === "Si" ? true : false);
      setIsShopActive(data?.isShopActive);
      setIsIconLoginActive(data?.isIconLoginActive);
      setShowPriceProducts(data?.showPriceProducts);
      setShowPriceServices(data?.showPriceServices);
      setShowSectionAddCardEvents(data?.showSectionAddCardEvents);
      setShowPriceEvents(data?.showPriceEvents);
      setShowCatalogDownloadInDetailsPage(data?.showCatalogDownloadInDetailsPage);
      setShowReviews(data?.showReviews);
      //console.log(`data?.applicativo =`, data?.applicativo);
      //console.log(`data?.linkWhatsapp =`, data?.linkWhatsapp);
      //console.log(`data?.linkFacebook =`, data?.linkFacebook);
      //console.log(`data?.linkInstagram =`, data?.linkInstagram);
      //console.log(`data?.linkTwitter =`, data?.linkTwitter);
      //console.log(`ragioneSociale =`, data?.ragioneSociale);
      //console.log(`urlCustomerImageServer =`, data?.urlCustomerImageServer);
      //console.log(`isShopActive =`, data?.isShopActive);
      //console.log(`isIconLoginActive =`, data?.isIconLoginActive);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [ragioneSociale, setEmail, setUrlCustomerImageServer])

  return (

    <Box sx={{ flexGrow: 1 }}>

      <Grid
        container
        size={{ xs: 12, md: 12 }}
        paddingTop={{ xs: 0, md: 0 }}
        paddingLeft={{ xs: 0, md: 0 }}
        paddingRight={{ xs: 0, md: 0 }}
        spacing={{ xs: 0, md: 0 }}
        sx={{
          //background: '#242424',    // sfondo sottomenu = nero
          background: '#2074d4'       // sfondo sottomenu = blu
        }}
      >
        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          size={{ xs: 12, md: 4 }}
          paddingTop={{ xs: 0, md: 0 }}
          paddingLeft={{ xs: 8, md: 17 }}   // per posizione dopo logo di sx
          paddingRight={{ xs: 1, md: 0 }}
          spacing={{ xs: 0, md: 0 }}
          color="white"
          //fontFamily="Roboto"
          fontFamily="sans-serif"
          textTransform='none'
          fontSize={14}
          //fontStyle= 'italic'
          //fontWeight= {100}
        >
          <Link underline="hover" color="inherit" href="/">
            <HomeOutlinedIcon />
          </Link>
          <Link
            underline="hover"
            color="inherit"
            href="/eventi"
          >
            {config.BC_EVENTI}
          </Link>
          <Typography
            sx={{
              color: 'white',
              fontFamily:"sans-serif",
              textTransform:'none',
              fontSize:14,
            }}
          >
            {event.name}
          </Typography>

        </Breadcrumbs>
      </Grid>

    {/* 
      <Breadcrumbs separator="›" aria-label="breadcrumb"
        size={{ xs: 12, md: 4 }}
        paddingTop={{ xs: 1, md: 1 }}
        paddingLeft={{ xs: 2, md: 6 }}
        paddingRight={{ xs: 1, md: 8 }}
        spacing={{ xs: 2, md: 2 }}
      >
        <Link underline="hover" color="inherit" href="/">
          <Typography
            sx={{
              color: 'text.primary',
              fontFamily: 'Roboto',
              textTransform: 'none',
              fontSize: 14,
            }}
          >
            {config.BC_HOME}
          </Typography>
        </Link>
        <Link
          underline="hover"
          color="inherit"
          href="/eventi"
        >
          <Typography
            sx={{
              color: 'text.primary',
              fontFamily: 'Roboto',
              textTransform: 'none',
              fontSize: 14,
            }}
          >
            {config.BC_EVENTI}
          </Typography>
        </Link>
        <Typography
          sx={{
            color: 'text.primary',
            fontFamily: 'Roboto',
            textTransform: 'none',
            fontSize: 14,
          }}
        >
          {event.name}
        </Typography>
      </Breadcrumbs>
    */}

      <Box
        sx={{
          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
          height: { xs: 0, md: 5 }
        }}
      />

      <Grid container spacing={{ xs: 2, md: 6 }}
      >

        <Grid
          size={{ xs: 0, md: 0.5 }}
          paddingTop={{ xs: 0, md: 0 }}
          paddingBottom={{ xs: 0, md: 0 }}
          paddingLeft={{ xs: 0, md: 0 }}
          paddingRight={{ xs: 0, md: 0 }}
        >
        </Grid>

        <Grid
          size={{ xs: 12, md: 3.8 }}
          paddingTop={{ xs: 0, md: 2 }}
          paddingBottom={{ xs: 0, md: 0 }}
          paddingLeft={{ xs: 0, md: 0 }}
          paddingRight={{ xs: 0, md: 0 }}
          style={{ zIndex: 1 }}
        >

          <Dialog open={open}>
            <Alert
              variant="filled"
              severity="info"
              onClose={() => { setOpen(false) }}
            >

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 20
                }}
              />

              <Typography variant="body1"
                sx={{
                  fontFamily: 'Arial',
                  fontWeight: 500,
                  fontSize: 16,
                  color: 'text.secondary',
                }}
              >
                Il prodotto è stato aggiunto al carrello
              </Typography>

              <Stack
                sx={{
                  paddingTop: 2, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  display: 'flex',
                  flexDirection: { xs: "row", md: "row" },
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >

                <Button
                  type="button"
                  variant="contained"
                  color="warning"
                  onClick={(e) => { goBack(e); }}
                  sx={{
                    width: "12ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                >
                  Acquisti
                </Button>

                <Button
                  type="button"
                  variant="contained"
                  color="success"
                  onClick={() => { navigate("/cart") }}
                  sx={{
                    width: "22ch",
                    p: { xs: 1, md: 1 },
                    m: { xs: 1, md: 1 },
                  }}
                >
                  Vai al carrello
                </Button>
              </Stack>

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 20
                }}
              />

            </Alert>
          </Dialog>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
            }}
          >

            <Paper
              sx={{
                paddingTop: 1, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                background: 'rgba(237, 242, 243, 0.61)',
                //background: '#edf2f3ff',
              }}
              elevation={6}
            >

              <Swiper
                pagination={{
                  type: 'fraction',
                  clickable: true,
                }}
                navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[FreeMode, Navigation, Thumbs, Pagination]}
                className="mySwiper2"
              >

                {images.map((slide, idx) =>

                  <div key={idx}>

                    {console.log("images=", images)}

                    <SwiperSlide>
                      <img src={slide.path} />
                      <div class="text-overlay" hidden={verificaContieneCaratteri(slide.title)}>

                        <Stack
                          sx={{
                            flexDirection: { xs: "column", md: "column" },
                          }}
                        >

                          <Typography
                            sx={{
                              //paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                              //p: 0, m: 0,
                              fontFamily: 'Arial',
                              fontWeight: 500,
                              fontSize: 18,
                              color: '#ffffff',
                            }}
                          >
                            {slide.title}
                          </Typography>

                          <Typography
                            sx={{
                              //paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                              //p: 0, m: 0,
                              fontFamily: 'Arial',
                              fontWeight: 300,
                              fontSize: 14,
                              color: '#ffffff',
                            }}
                          >
                            {slide.subTitle}
                          </Typography>

                        </Stack>

                      </div>
                      <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                    </SwiperSlide>

                  </div>

                )}

              </Swiper>

              <Swiper
                onSwiper={setThumbsSwiper}
                spaceBetween={5}
                slidesPerView={5}
                freeMode={true}
                watchSlidesProgress={true}
                modules={[FreeMode, Navigation, Thumbs]}
                className="mySwiper"
              >
                {images.map((slide, idx) =>

                  <div key={idx}>

                    {console.log("images=", images)}

                    <SwiperSlide title={slide.title} >
                      <img src={slide.path} />
                    </SwiperSlide>

                  </div>
                )}
              </Swiper>

            </Paper>

          </Box>

        </Grid>

        <Grid
          size={{ xs: 12, md: 7 }}
          sx={{
            paddingTop: 2, paddingBottom: 0, paddingLeft: 2, paddingRight: 2,
          }}
        >

          <Paper
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              background: '#bfdae3ff',
            }}
            elevation={6}
          >

            <Stack
              spacing={0}
              sx={{ flexDirection: { xs: "column", md: "column" }, paddingTop: 1, paddingLeft: 3, paddingRight: 0, }}
            >

              <Grid container spacing={2}
                sx={{
                  paddingTop: 2,
                }}
              >

                <Grid size={{ xs: 12, md: 8 }}>

              <Typography variant="body1"
                sx={{
                  fontFamily: 'Arial',
                  fontWeight: 700,
                  fontSize: { xs: 24, md: 30 },
                  color: 'text.primary',
                  paddingTop: 1
                }}
              >
                {event.name}
              </Typography>

              <Typography variant="body2"
                sx={{
                  color: 'text.secondary',
                  fontSize: 20,
                  paddingTop: 1
                }}
              >
                {event.description}
              </Typography>

              <Typography variant="body2"
                sx={{
                  fontFamily: 'sans-serif',
                  fontStyle: 'italic',
                  fontWeight: 300,
                  color: 'text.secondary',
                  fontSize: 12,
                  paddingTop: 2,
                  paddingRight: 3,
                }}
              >
                {event.note}
              </Typography>

                  <Grid
                    sx={{
                      paddingTop: 2, paddingBottom: 0, paddingLeft: { xs: 0, md: 2 }, paddingRight: 0,
                    }}
                  >

                   <Box
                      display={showCatalogDownloadInDetailsPage === 'Si' ? "block" : "none"}
                      sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}
                    >

                      <Button
                        type="button"
                        variant="contained"
                        color="success"
                        //size="small"
                        sx={{
                          width: "20ch",
                          p: { xs: 1, md: 1 },
                          m: { xs: 1, md: 1 },
                          borderRadius: 35,
                          backgroundColor: "#21b6ae",
                        }}
                      >

                        <a href={pathPdfsToDwn} target="_blank" download={namePdfsToDwn}
                          style={{
                            color: "#FFFFFF",
                            textDecoration: "none"
                          }
                          }>
                          <Stack
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            spacing={0}
                            my={0}                  >

                            <Typography
                              sx={{
                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                                color: 'white',
                                fontFamily: 'Roboto',
                                textTransform: 'none',
                                fontSize: 16,
                              }}
                            >
                              Download catalogo &nbsp;
                              <DownloadTwoToneIcon
                                fontSize="inherit"
                              >
                              </DownloadTwoToneIcon>
                            </Typography>
                          </Stack>
                        </a>
                      </Button>

                    </Box>

                  </Grid>

                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>

                  <Box
                    display={showSectionAddCardEvents === 'Si' ? "block" : "none"}
                    sx={{ '& > :not(style)': { m: 1, width: '25ch', paddingTop: { xs: 0, md: 0 } }, paddingLeft: { xs: 4, md: 0 } }}
                    noValidate
                    autoComplete="off"
                  >

                    <TextField id="id-disponible" label="Disponibile" variant="outlined" value={event.count > 0 ? "in stock" : "out of stock"}
                      size="small"
                      slotProps={{
                        input: { readOnly: true },
                        inputLabel: { shrink: true }
                      }}
                      onChange={(event) => {
                        //setName(event.target.value);
                      }}
                    />

                    <TextField id="id-prezzo" label="Prezzo" variant="outlined" value={strEuroCurrency(event.price)}
                      size="small"
                      slotProps={{
                        input: { readOnly: true },
                        inputLabel: { shrink: true },
                      }}
                      onChange={(event) => {
                        //setName(event.target.value);
                      }}
                    />

                    <TextField id="id-quantity" label="Quantità" variant="outlined" value={quantity} type="number"
                      size="small"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      InputProps={{
                        inputProps: {
                          max: 100, min: 0
                        }
                      }}
                      onChange={(event) => {
                        setQuantity(event.target.value);
                      }}
                    />

                    <Button
                      type="button"
                      variant="contained"
                      color="success"
                      //size="small"
                      onClick={(e) => {
                        addToCartHandler(e);
                        handleClickOpen();
                      }}
                      sx={{
                        width: "20ch",
                        borderRadius: 35,
                        backgroundColor: "#148840",
                      }}
                    >
                      <Stack
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={0}
                        my={0}
                      >
                        <Typography
                          sx={{
                            paddingTop: 1, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                            color: 'white',
                            fontFamily: 'Roboto',
                            textTransform: 'none',
                            fontSize: 16,
                          }}
                        >
                          Aggiungi al carrello &nbsp;
                          <AddShoppingCartIcon
                            fontSize="inherit"
                          >
                          </AddShoppingCartIcon>
                        </Typography>
                      </Stack>
                    </Button>

                  </Box>

                </Grid>

              </Grid>

                <Grid container spacing={2}
                sx={{
                  paddingTop: 2,
                }}
              >

                <Grid size={{ xs: 12, md: 4 }}>
                  <Box display={showPriceEvents === 'Si' ? "block" : "none"}>
                    <Item>
                      <Typography variant="body2"
                        sx={{
                          color: 'text.secondary',
                          fontSize: 16,
                        }}
                      >
                        Prezzo &nbsp; <b>{strEuroCurrency(event.price)}</b>
                      </Typography>
                    </Item>
                  </Box>
                </Grid>

                <Grid size={3}>
                  <Box display={showReviews === 'Si' ? "block" : "none"}>
                  <Item>
                    <Typography variant="body2"
                      sx={{
                        color: 'text.secondary',
                        paddingTop: 0,
                        fontSize: 14,
                      }}
                    >
                      <Rating
                        readOnly
                        size="small"
                        name="half-rating"
                        initialValue={event.rating}
                        precision={0.5}
                      />
                      ({event.reviewsNumber ? event.reviewsNumber : 0})
                    </Typography>
                  </Item>
                  </Box>
                </Grid>

                <Grid size={{ xs: 12, md: 5 }}>
                  <Item>
                    <Link to={url_elencoEventi}>
                      <Tooltip title={help_image_elencoEventi} arrow placement="right-end">
                        <Box
                          component="img"
                          paddingTop={{ xs: 0, md: 0 }}
                          paddingLeft={{ xs: 0, md: 0 }}
                          sx={{
                            height: size_linkToAllEvents,
                            width: size_linkToAllEvents,
                            maxHeight: { xs: size_linkToAllEvents, md: size_linkToAllEvents },
                            maxWidth: { xs: size_linkToAllEvents, md: size_linkToAllEvents },
                          }}
                          src={url_image_elencoEventi}
                          onClick={event => {
                            navigate(url_elencoEventi)
                          }}
                        >
                        </Box>
                      </Tooltip>
                    </Link>

                  </Item>
                </Grid>
              </Grid>

            </Stack>

          </Paper>
        </Grid>

      </Grid>

      <Box
        sx={{
          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
          height: 30
        }}
      />

    </Box>
  );
};

export default EventDetailsPageComponent;
